import {
  DEFAULT_VALUE, IPostLoggingData,
  ISendLoggingEventProps,
  sendLoggingEvent,
} from "./sendLoggingEvent";
import {
  EnumActionNameLevel1,
  EnumActionNameLevel2,
  EnumActionNameLevel3,
  EnumCellType,
  EnumGeneratedBy,
  EnumLoggingScreenNames,
  EnumReferenceEntity,
  EnumUserTargetType,
  EnumUxTypes,
  EnumWidgets,
} from "../types/loggingTypes";
import { IPostData } from "models/post";
import { IJobPosterPostView, IJobSeekerPostView } from "models/jobPostView";
import { LocalStorageConstants } from "utils/constants";
import { isBrowser } from "utils/nookies/utils";
import { getLastScreenName } from "./loggingActions";
import { iPostListingData } from "../../../screens/PostView/_private/Api/types";
export const shareLogging = ({
  actionNameLevel2,
  currentWidgetName = EnumWidgets.SHARE_DIALOG,
  referenceEntity,
  targetId,
  referenceId,
  uxType = EnumUxTypes.BUTTON,
  postData,
  isShop,
}: {
  actionNameLevel2: EnumActionNameLevel2;
  currentWidgetName?: EnumWidgets;
  referenceEntity?: EnumReferenceEntity;
  targetId: number;
  referenceId?: number;
  uxType?: EnumUxTypes;
  postData?: IPostLoggingData;
  isShop?: boolean;
}) => {
  const loggingData = {
    post: postData,
    actionNameLvl1: EnumActionNameLevel1.SHARE,
    actionNameLvl2: actionNameLevel2,
    actionNameLvl3: EnumActionNameLevel3.CLICK,
    currentWidgetName,
    ux_type: uxType,
    generatedBy: EnumGeneratedBy.USER,
    userTargetType: isShop || postData?.member_isShop ? EnumUserTargetType.Membership : EnumUserTargetType.Free,
    targetId,
    referenceEntity,
    referenceId,
  };
  sendLoggingEvent(loggingData as ISendLoggingEventProps);
};

export const handleLoggingAuthenticate = ({
  currentWidgetName,
  ux_type = EnumUxTypes.BUTTON,
  cellType,
}: {
  currentWidgetName?: EnumWidgets;
  ux_type?: EnumUxTypes;
  cellType?: EnumCellType;
}) => {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.AUTHENTICATE,
    actionNameLvl2: EnumActionNameLevel2.COMMON,
    actionNameLvl3: EnumActionNameLevel3.CLICK,
    currentWidgetName,
    ux_type: ux_type,
    generatedBy: EnumGeneratedBy.USER,
    cellType: cellType,
    sessionFunnel: localStorage.getItem(
      LocalStorageConstants.CURRENT_LOGGING_SCREEN_NAME
    ),
  } as ISendLoggingEventProps);
};
